import { getFileTask } from "@/api/h5/file";

const DEFAULT_INTERVAL = 1500;
const DEFAULT_MAX_ATTEMPTS = 80;

const sleep = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));

const normalizeFileInfo = (data) => {
  if (!data) return null;
  if (data.fileInfo) return data.fileInfo;
  if (data.fileId) return data;
  return null;
};

const normalizeTaskInfo = (data, allowStatusOnly = false) => {
  if (!data) return null;
  if (data.taskInfo !== undefined) return data.taskInfo;
  if (allowStatusOnly && data.status) return data;
  if (data.taskId && data.status) return data;
  return null;
};

const getTaskErrorMessage = (taskInfo, options) => {
  if (taskInfo.message) return taskInfo.message;
  if (taskInfo.status === "EXPIRED") {
    return options.expiredMessage || "创建副本任务已过期";
  }
  return options.fallbackMessage || "创建副本失败";
};

const resolveResponseBody = (res, fallbackMessage) => {
  const body = res?.data?.code ? res.data : res;
  if (body?.code && body.code !== 200) {
    throw new Error(body.message || fallbackMessage);
  }
  return body?.data ?? body;
};

export const waitFileCopyTaskComplete = async (copyResult, options = {}) => {
  const fileInfo = normalizeFileInfo(copyResult);
  const taskInfo = normalizeTaskInfo(copyResult);
  const interval = options.interval ?? DEFAULT_INTERVAL;
  const maxAttempts = options.maxAttempts ?? DEFAULT_MAX_ATTEMPTS;
  const fallbackMessage = options.fallbackMessage || "创建副本失败";

  if (!fileInfo) {
    throw new Error(fallbackMessage);
  }

  if (!taskInfo || taskInfo.status === "SUCCESS") {
    return fileInfo;
  }

  if (taskInfo.status === "FAIL" || taskInfo.status === "EXPIRED") {
    throw new Error(getTaskErrorMessage(taskInfo, options));
  }

  if (taskInfo.status !== "PROCESSING") {
    throw new Error(fallbackMessage);
  }

  if (!taskInfo.taskId) {
    throw new Error("创建副本任务缺少 taskId");
  }

  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    await sleep(interval);

    const taskRes = await getFileTask(taskInfo.taskId);
    const taskData = resolveResponseBody(taskRes, "查询创建副本任务失败");
    const latestTaskInfo = normalizeTaskInfo(taskData, true);
    const latestFileInfo = normalizeFileInfo(taskData) || fileInfo;

    if (!latestTaskInfo) {
      throw new Error("查询创建副本任务失败");
    }

    if (latestTaskInfo.status === "SUCCESS") {
      return latestFileInfo;
    }

    if (latestTaskInfo.status === "FAIL" || latestTaskInfo.status === "EXPIRED") {
      throw new Error(getTaskErrorMessage(latestTaskInfo, options));
    }

    if (latestTaskInfo.status !== "PROCESSING") {
      throw new Error(fallbackMessage);
    }
  }

  throw new Error("创建副本处理中，请稍后刷新查看");
};

